var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',[_c('template',{slot:"content"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{class:'mul-ellipsis' + _vm.lineNum},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }